<template>
  <!-- :title="$t('dialog.titleSelectionPackageAndPackageGroup')" -->
  <el-dialog
    title="Cập nhật giá hạng phòng"
    :visible="isShow"
    :close-on-click-modal="false"
    append-to-body
    width="600px"
    @close="onClose"
  >
    <div class="das-form-container">
      <!-- <div class="das-info-title">Thông tin giai đoạn & hạng phòng</div> -->
      <InfoList
        :columns="6"
        :column-breakpoint-options="{
          sm: 1,
          md: 6
        }"
      >
        <InfoListLabel style="max-width: 300px">{{
          $t('field.period')
        }}</InfoListLabel>

        <InfoListValue style="max-width: 300px">{{
          priceByLevel?.code
        }}</InfoListValue>

        <InfoListLabel>{{ $t('field.roomLevel') }}</InfoListLabel>
        <InfoListValue style="max-width: 300px">
          {{ roomLevel?.room_level_nm }}
        </InfoListValue>
      </InfoList>
      <div :v-loading="false" style="height: 300px">
        <GridVx
          ref="agGrid"
          dom-layout="scroll"
          :columns="columns"
          :rows="rows"
          :auto-select-first-row="false"
          :row-multi-select-with-click="true"
          :context="context"
          class="agGrid"
        />
      </div>
      <div class="note-section"></div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="button-containers flex justify-end" style="gap: 10px">
        <button class="btn primary small" @click="fnSave">
          {{ $t('button.save') }}
        </button>
        <button class="btn primary small outline" @click="onClose">
          {{ $t('button.cancel') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import CellRenderCurrency from './CellRenderCurrency.vue'
// eslint-disable-next-line no-unused-vars
import { editPriceRoomLevelApi } from '@/api/Service_Policy/priceCode'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCurrency
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    priceByLevel: {
      type: Object
    },
    roomLevel: {
      type: Object
    }
  },
  data() {
    return {
      columns: [
        {
          headerName: '',
          minWidth: 40,
          maxWidth: 40,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Ngày trong tuần',
          field: 'day_of_week',
          valueFormatter: params => {
            switch (params.value) {
              case 2:
                return this.$t('variables.mon')
              case 3:
                return this.$t('variables.tue')
              case 4:
                return this.$t('variables.wed')
              case 5:
                return this.$t('variables.thu')
              case 6:
                return this.$t('variables.fri')
              case 7:
                return this.$t('variables.sat')
              case 8:
                return this.$t('variables.sun')
              default:
                return
            }
          },
          // cellClass: 'grid-cell-centered',
          // flex: 1
          sortable: false,
          width: 200
        },
        {
          headerName: 'Giá',
          field: 'price',
          cellRenderer: 'CellRenderCurrency',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          sortable: false
        }
      ],
      rows: [
        {
          day_of_week: 2,
          price: null
        },
        {
          day_of_week: 3,
          price: null
        },
        {
          day_of_week: 4,
          price: null
        },
        {
          day_of_week: 5,
          price: null
        },
        {
          day_of_week: 6,
          price: null
        },
        {
          day_of_week: 7,
          price: null
        },
        {
          day_of_week: 8,
          price: null
        }
      ],

      curRowFocusIdx: null
    }
  },
  watch: {
    isShow: {
      handler(val) {
        if (val) {
          this.attachData()
        }
      },
      immediate: true
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },

  methods: {
    attachData() {
      this.rows.forEach((row, index) => {
        switch (row.day_of_week) {
          case 2:
            this.rows[index].price = this.roomLevel.day_2
            break
          case 3:
            this.rows[index].price = this.roomLevel.day_3
            break
          case 4:
            this.rows[index].price = this.roomLevel.day_4
            break
          case 5:
            this.rows[index].price = this.roomLevel.day_5
            break
          case 6:
            this.rows[index].price = this.roomLevel.day_6
            break
          case 7:
            this.rows[index].price = this.roomLevel.day_7
            break
          case 8:
            this.rows[index].price = this.roomLevel.day_8
            break
          default:
            break
        }
      })

      this.rows = [...this.rows]
    },

    fnBlurCurrencyInput(params, value, field) {
      const gridApi = this.$refs.agGrid.gridApi
      gridApi.forEachNode(node => {
        if (node.rowIndex === params.rowIndex) {
          node.setDataValue(field, value)
        }
      })

      this.curRowFocusIdx = null
      // this.fnUpdatePriceRoomLevel()
    },
    fnFocusCurrencyInput(params, value, field) {
      this.curRowFocusIdx = params.rowIndex
    },
    fnChangeCurrencyInput(params, value, field) {
      const idx = params.rowIndex
      // eslint-disable-next-line no-unused-vars
      const currentRoomLevelRow = this.rows[idx]

      // if (currentRoomLevelRow[field] !== value) {
      if (this.curRowFocusIdx === idx) {
        const gridApi = this.$refs.agGrid.gridApi
        const selectedNode = gridApi.getSelectedNodes()
        // const selectedIndexList = selectedNode.map(item => item.rowIndex)
        // const newRows = []

        selectedNode.forEach(node => {
          if (node.rowIndex !== idx) {
            node.setDataValue(field, value)
          }
        })
      }
    },

    fnUpdatePriceRoomLevel() {
      const isValidPrice = this.rows.every(rows => {
        return rows.price !== null && rows.price !== undefined
      })

      if (isValidPrice) {
        const payload = {
          price_by_level_id: this.priceByLevel?.id,
          room_level_id: this.roomLevel?.room_level_id,
          price_room_level: this.rows
        }
        editPriceRoomLevelApi(payload)
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('successMsg.' + res.message)
            })
            // const priceData = {
            //   day_2: null,
            //   day_3: null,
            //   day_4: null,
            //   day_5: null,
            //   day_6: null,
            //   day_7: null,
            //   day_8: null
            // }

            const priceData = new Map()

            this.rows.forEach(row => {
              const key = `day_${row.day_of_week}`
              priceData.set(key, row.price)
            })

            this.$emit('updatePriceRoomLevel', priceData)
            this.$emit('close')
          })
          .catch(err => {
            this.$message({
              type: 'error',
              message: err.response.data.message || 'An error occurred'
            })
          })
      } else {
        this.$message({
          type: 'error',
          message: 'Vui lòng điền giá của tất cả các ngày trong tuần'
        })
      }
    },

    fnSave() {
      this.fnUpdatePriceRoomLevel()
    },
    onClose() {
      this.$emit('close')
    }
  }
}
</script>

<style></style>

<style lang="scss" scoped>
.note-section {
}
</style>
